/*eslint no-useless-computed-key: "off"*/
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import mobileWrapper from "assets/jss/material-dashboard-pro-react/componentsCustom/mobileWrapper.js";

const useStyles = makeStyles(mobileWrapper);

export default function MobileButton(props) {
  const {
    onClick,
    color,
    text,
    isActive,
    path,
    className,
    classNameText,
    nButtons,
    index,
    rightComponent,
    leftComponent,
    isLinkActive,
    customStyle,
    customColor
  } = props;

  const classes = useStyles();

  let mB = 0;
  if (nButtons !== index + 1) {
    mB = "10px";
  }

  let sizeGrid = 12;
  if (leftComponent) {
    sizeGrid -= 3;
  }
  if (rightComponent) {
    sizeGrid -= 3;
  }

  const buttonDisplay = (
    <GridContainer style={{ width: "inherit", margin: "0px" }}>
      {leftComponent ? (
        <GridItem
          xs={3}
          sm={3}
          md={3}
          lg={3}
          style={{ textAlign: "left", padding: "0px !important" }}
        >
          {leftComponent}
        </GridItem>
      ) : null}

      <GridItem xs={sizeGrid} sm={sizeGrid} md={sizeGrid} lg={sizeGrid}>
        <span
          className={classNameText ? classNameText : classes.buttonBigText}
          style={{ color: customColor }}
        >
          {text}
        </span>
      </GridItem>
      {rightComponent ? (
        <GridItem
          xs={3}
          sm={3}
          md={3}
          lg={3}
          style={{ textAlign: "right", padding: "0px !important" }}
        >
          {rightComponent}
        </GridItem>
      ) : null}
    </GridContainer>
  );

  return (
    <Button
      color={color}
      className={`${classes.buttonBig}${className ? ` ${className}` : ""}`}
      onClick={onClick}
      disabled={!isActive}
      style={Object.assign({}, { marginBottom: mB }, customStyle)}
    >
      {path ? (
        <Link
          className={`${classes.linkStyle}${
            !isLinkActive ? ` ${classes.disabledLink}` : ""
          }`}
          to={path}
        >
          {buttonDisplay}
        </Link>
      ) : (
        <>{buttonDisplay}</>
      )}
    </Button>
  );
}

MobileButton.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.string,
  text: PropTypes.string,

  isActive: PropTypes.bool,
  rightComponent: PropTypes.node,
  leftComponent: PropTypes.node,
  isLinkActive: PropTypes.bool,
  path: PropTypes.string,
  className: PropTypes.string,
  classNameText: PropTypes.string,
  nButtons: PropTypes.number,
  index: PropTypes.number,

  customStyle: PropTypes.object,
  customColor: PropTypes.string
};
MobileButton.defaultProps = {
  onClick: () => {},
  color: "transparent",
  text: "",
  isActive: false,
  rightComponent: null,
  leftComponent: null,
  isLinkActive: true,
  path: "",
  className: "",
  classNameText: "",
  nButtons: 0,
  index: 0,
  customStyle: {},
  customColor: ""
};
